export var ISO_DATE_TIME_FORMAT = 'yyyy-MM-dd';
export var SCHEMA_ORG_CONTEXT = 'https://schema.org';
export var SCHEMA_ORG_TYPE_PERSON = 'Person';
export var SCHEMA_ORG_TYPE_IMAGE = 'ImageObject';
export var SCHEMA_ORG_TYPE_BLOG = 'BlogPosting';
export var OG_META_TAG_NAME_ARTICLE_AUTHOR = 'og:article:author';
export var OG_META_TAG_NAME_ARTICLE_PUBLISHED = 'og:article:published_time';